// extracted by mini-css-extract-plugin
export var buttons = "_9h-0";
export var buttonsActive = "_9h-h";
export var cancelConfirm = "_9h-1";
export var closeButton = "_9h-2";
export var column = "_9h-3";
export var container = "_9h-4";
export var detailHeader = "_9h-6";
export var detailTitle = "_9h-7";
export var detailsContent = "_9h-5";
export var header = "_9h-8";
export var headerWithClose = "_9h-9";
export var icon = "_9h-a";
export var infoIcon = "_9h-c";
export var informationContainer = "_9h-b";
export var sideDrawer = "_9h-d";
export var sideDrawerOpen = "_9h-e";
export var stickyFooter = "_9h-f";
export var typeOption = "_9h-g";